/* @flow weak */
// typecheck: ignore file
import React from 'react';

import EventTracking, { getEventScreenName, getEventElementName, getEventContextName, getEventProperties } from 'lib/EventTracking';
import createChainedFunction from 'utils/createChainedFunction';

type Props = {
  eventElementName?: ?string,
  screenName?: ?string,
  eventProperties?: ?Object,
  children?: *,
}

class ClickEventTrigger extends React.Component {
  props: Props;

  static contextTypes = {
    eventScreenName: React.PropTypes.string,
    eventProperties: React.PropTypes.object,
    eventContextName: React.PropTypes.string,
    router: React.PropTypes.object,
  }

  trackClick = () => {
    const elementName = getEventElementName(this.props);
    const screenName = getEventScreenName(this.props, this.context.router);
    if (elementName && screenName) {
      EventTracking.tap(
        screenName,
        elementName,
        getEventContextName(this.props, this.context),
        getEventProperties(this.props.eventProperties, this.context)
      );
    }
  }

  render() {
    const child = React.Children.only(this.props.children);
    return React.cloneElement(child, { ...child.props,
      onClick: createChainedFunction(this.trackClick, child.props.onClick),
    });
  }
}

export default ClickEventTrigger;



// WEBPACK FOOTER //
// ./src/components/ClickEventTrigger.jsx